module.exports = __webpack_public_path__ + "img/listening-speaker.993aeb88.svg";